if (!customElements.get('specification-modal')) customElements.define('specification-modal', class SpecificationModal extends HTMLElement {

  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeButton = this.querySelector('.modal__close-button');
    this.specName = this.dataset.name;
    this.navButtons = this.querySelectorAll('.specification__navigation-button');
    this.curtain = this.querySelector('.modal__curtain');
    this.stickyAtc = document.querySelector('sticky-atc');
    this.header = document.querySelector('.section-header');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );

    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  connectedCallback() {
    this.navButtons.forEach((button) => {
      const buttonContent = handleize(button.textContent);
      if (buttonContent === this.specName) {
        button.classList.add('active');
      }

      button.addEventListener('click', this.navItemHandler.bind(this));
    });

    this.curtain.addEventListener('click', this.close.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    if(event.target.closest('.upsell-quantity')) return;
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  navItemHandler = (event) => {
    const buttonContent = handleize(event.target.textContent);
    this.open({ target: document.querySelector(`specification-modal[data-name="${buttonContent}"] details`) });
    this.changeModalClose(event);
  }

  open(event) {
    const el = event.target.closest('details') || target
    const scrollableContent = el.querySelector('.specification-modal__content--wrapper');
    el.setAttribute('open', '');
    this.header.classList.add('hidden');

    const navItemActive = el.querySelector('.specification__navigation-button.active');
    navItemActive.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });


    if(!event.target.classList.contains('header__icon--search')){
      document.body.classList.add('overflow-hidden');
    }
    if (this.stickyAtc) {
      this.stickyAtc.style.opacity = "0";
      this.stickyAtc.style.zIndex = "-1";
    }

    scrollableContent.scrollTop = 0;

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('slider-component')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    this.stickyAtc.style.opacity = "1";
    this.stickyAtc.style.zIndex = "10";
    this.header.classList.remove('hidden');
  }

  changeModalClose(event) {
    event.target.closest('details').removeAttribute('open');
  }
});
